// app/api/typedBaseQuery.ts
import type { BaseQueryFn } from "@reduxjs/toolkit/query/react";
import { coreApi } from "../core-api";

interface ApiError {
    status: number;
    data: any;
    message?: string;
}

interface BaseQueryArgs {
    url: string;
    method: "GET" | "POST" | "PUT" | "PATCH" | "DELETE";
    data?: any;
    params?: any;
    noAuth?: boolean;
}

// Type-safe version where T is the expected return type
export const createTypedBaseQuery = <T = any>(): BaseQueryFn<BaseQueryArgs, T, ApiError> => {
    return async ({ url, method, data, params, noAuth = false }) => {
        try {
            let result: T;

            switch (method) {
                case "GET":
                    result = await coreApi.get<T>(url, params);
                    break;
                case "POST":
                    result = await coreApi.post<T>(url, data, noAuth);
                    break;
                case "PUT":
                    result = await coreApi.put<T>(url, data);
                    break;
                case "PATCH":
                    result = await coreApi.patch<T>(url, data);
                    break;
                case "DELETE":
                    result = await coreApi.remove<T>(url, params);
                    break;
                default:
                    throw new Error(`Unsupported method: ${method}`);
            }
            return { data: result };
        } catch (axiosError: any) {
            const error: ApiError = {
                status: axiosError.response?.status || 500,
                data: axiosError.response?.data || axiosError.message,
                message: axiosError.message,
            };

            return { error };
        }
    };
};

// Export the default baseQuery
export const baseQuery = createTypedBaseQuery();
